import { render, staticRenderFns } from "./SiteIndex.vue?vue&type=template&id=8dbe442a"
import script from "./SiteIndex.vue?vue&type=script&lang=js"
export * from "./SiteIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports